var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22,
    stroke: "#EE7225",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.625C17 14.1663 17.5795 12.7674 18.6109 11.7359C19.6424 10.7045 21.0413 10.125 22.5 10.125C23.9587 10.125 25.3576 10.7045 26.3891 11.7359C27.4205 12.7674 28 14.1663 28 15.625C28 17.0837 27.4205 18.4826 26.3891 19.5141C25.3576 20.5455 23.9587 21.125 22.5 21.125C21.0413 21.125 19.6424 20.5455 18.6109 19.5141C17.5795 18.4826 17 17.0837 17 15.625ZM17 23.875C15.1766 23.875 13.428 24.5993 12.1386 25.8886C10.8493 27.178 10.125 28.9266 10.125 30.75C10.125 31.844 10.5596 32.8932 11.3332 33.6668C12.1068 34.4404 13.156 34.875 14.25 34.875H30.75C31.844 34.875 32.8932 34.4404 33.6668 33.6668C34.4404 32.8932 34.875 31.844 34.875 30.75C34.875 28.9266 34.1507 27.178 32.8614 25.8886C31.572 24.5993 29.8234 23.875 28 23.875H17Z",
    fill: "#EE7225"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.6ca7dd4e8b0028c40d168c1e284fdcdb.svg";
export { ForwardRef as ReactComponent };